<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">School Staff</h3>
        </div>
        <div class="col-auto float-right ml-auto">
          <button
            class="btn add-btn"
            @click="
              $router.push({
                name:
                  tokenObj.UserType == userTypeMainAdmin
                    ? 'mainAdminInstructorAdd'
                    : 'schoolAdminInstructorAdd',
              })
            "
          >
            <i class="fa fa-plus"></i>Add School Staff
          </button>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <!-- Search Filter -->
    <div class="row">
      <div class="col-md-3" v-if="tokenObj.UserType == userTypeMainAdmin">
        <div class="form-group">
          <label>School</label>
          <select class="form-control" v-model="schoolId">
            <option value>All</option>
            <option v-for="item in schools" :value="item.Id" :key="item.Id">
              {{ item.Name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>Staff Name</label>
          <input
            type="text"
            placeholder="Search Name Here"
            class="form-control"
            v-model="name"
          />
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
          <label>User Type (Filter)</label>
          <select class="form-control" v-model="userTypeName">
            <option value>All</option>
            <option
              v-for="item in userTypes"
              :value="item.Name"
              :key="item.Name"
            >
              {{ item.Name }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label>Status (Filter)</label>
          <select class="form-control" v-model="status">
            <option value>All</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>
      </div>
      <div class="col-md-1">
        <button class="btn btn-primary filter-btn" @click="search">View</button>
      </div>
    </div>
    <!-- /Search Filter -->

    <!-- Pagination -->
    <div class="row mt-3">
      <div class="col-md-6">
        Show
        <select
          class="custom-select custom-select-sm"
          v-model="paging.SizePerPage"
          style="width: 5em"
        >
          <option
            v-for="item in paging.Sizes"
            v-bind:key="item"
            v-bind:value="item"
          >
            {{ item }}
          </option>
        </select>
        entries
      </div>
    </div>
    <!-- /Pagination -->

    <!-- Table List -->
    <div class="row mt-2">
      <div class="col-md-12">
        <div class="table-responsive mb-lg-0 mb-md-0 mb-sm-1">
          <table class="table table-bordered custom-table mb-0">
            <thead class="thead-light">
              <tr>
                <th class="no-col">S/N</th>
                <th class="usertype-col">
                  <button class="btn p-0" @click="setSortBy('userType')">
                    User Type
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'userType'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'userType_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="id-col">
                  <button class="btn p-0" @click="setSortBy('id')">
                    ID
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'id'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'id_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="name-col">
                  <button class="btn p-0" @click="setSortBy('name')">
                    Name
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'name'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'name_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="contact-col">
                  <button class="btn p-0" @click="setSortBy('contactNumber')">
                    Contact Number
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'contactNumber'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'contactNumber_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="status-col">
                  <button class="btn p-0" @click="setSortBy('status')">
                    Status
                    <span class="tableHeaderSortIcon">
                      <i
                        class="fa fa-long-arrow-up ml-3"
                        :style="[
                          paging.SortBy === 'status'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                      <i
                        class="fa fa-long-arrow-down"
                        :style="[
                          paging.SortBy === 'status_desc'
                            ? { color: 'orange' }
                            : { color: 'white' },
                        ]"
                      ></i>
                    </span>
                  </button>
                </th>
                <th class="action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, i) in instructors" :key="item.Id">
                <td class="no-col">
                  {{
                    paging.CurrentPage * paging.SizePerPage -
                    paging.SizePerPage +
                    i +
                    1
                  }}
                </td>
                <td class="usertype-col">{{ item.UserTypeName }}</td>
                <td class="id-col">{{ item.UserName }}</td>
                <td class="name-col">{{ item.Name }}</td>
                <td class="contact-col">{{ item.ContactNumber }}</td>
                <td class="status-col">{{ item.Status }}</td>
                <td class="action-col">
                  <div class="dropdown dropdown-action">
                    <a
                      href="#"
                      class="action-icon dropdown-toggle"
                      data-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="material-icons">more_vert</i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name:
                              tokenObj.UserType == userTypeMainAdmin
                                ? 'mainAdminInstructorShow'
                                : 'schoolAdminInstructorShow',
                            params: { id: item.Id },
                          })
                        "
                      >
                        <i class="far fa-file-alt mr-2"></i>View
                      </button>
                      <button
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name:
                              tokenObj.UserType == userTypeMainAdmin
                                ? 'mainAdminInstructorEdit'
                                : 'schoolAdminInstructorEdit',
                            params: { id: item.Id },
                          })
                        "
                      >
                        <i class="fa fa-pencil mr-2"></i>Edit
                      </button>
                      <button
                        class="dropdown-item"
                        @click="deleteInstructor(item.Id)"
                      >
                        <i class="fa fa-trash-o mr-2"></i>Delete
                      </button>
                      <button
                        v-if="
                          item.UserTypeName == userTypeInstructor ||
                          item.UserTypeName == userTypeInstructorSchoolAdmin
                        "
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name:
                              tokenObj.UserType == userTypeMainAdmin
                                ? 'mainAdminInstructorSchedule'
                                : 'schoolAdminInstructorSchedule',
                            params: { id: item.Id },
                          })
                        "
                      >
                        <i class="far fa-calendar-alt mr-2"></i>View Schedule
                      </button>
                      <button
                        class="dropdown-item"
                        @click="
                          $router.push({
                            name:
                              tokenObj.UserType == userTypeMainAdmin
                                ? 'mainAdminInstructorDocument'
                                : 'schoolAdminInstructorDocument',
                            params: { id: item.Id },
                          })
                        "
                      >
                        <i class="far fa-folder-open mr-1"></i>View Documents
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr v-if="instructors && !instructors.length">
                <td colspan="7" class="text-center">
                  {{ noRecordText }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- /Table List -->

    <!--Pagination -->
    <div class="row mb-4" v-if="instructors && instructors.length">
      <div
        class="col-md-6 col-lg-6 col-sm-6 my-auto text-center text-lg-left text-md-left"
      >
        Showing
        {{ paging.CurrentPage * paging.SizePerPage - paging.SizePerPage + 1 }}
        to
        {{
          paging.CurrentPage * paging.SizePerPage -
          paging.SizePerPage +
          instructors.length
        }}
        of {{ totalRecords }} entries
      </div>

      <div class="col-md-6 col-lg-6 col-sm-6 pr-md-0 pr-lg-0">
        <div class="navbar justify-content-end">
          <button
            v-on:click="first()"
            v-if="paging.CurrentPage != 1"
            class="btn btn-sm btn-white"
          >
            First
          </button>
          <button
            v-on:click="prev()"
            class="btn btn-sm btn-white ml-1 mr-3"
            v-if="paging.CurrentPage > 1"
          >
            Prev
          </button>
          Page
          <input
            class="form-control form-control-sm mx-1"
            type="number"
            step="1"
            min="1"
            :max="paging.TotalPage"
            v-model="paging.CurrentPage"
            @change="onCurrentPageChange($event)"
            style="width: 4rem"
          />

          <span>of {{ paging.TotalPage }}</span>
          <button
            v-on:click="next()"
            class="btn btn-sm btn-white ml-3 mr-1"
            v-if="paging.CurrentPage < paging.TotalPage"
          >
            Next
          </button>
          <button
            v-on:click="last()"
            v-if="paging.CurrentPage != paging.TotalPage"
            class="btn btn-sm btn-white"
          >
            Last
          </button>
        </div>
      </div>
    </div>
    <!--/Pagination -->
  </div>
</template>

<script>
import API from "../../../http-common.js";
import config from "../../../config.js";
export default {
  data() {
    return {
      userTypeMainAdmin: config.USERTYPE_MAIN_ADMIN,
      userTypeInstructor: config.USERTYPE_INSTRUCTOR,
      userTypeInstructorSchoolAdmin:
        config.USERTYPE_INSTRUCTOR_AND_SCHOOL_ADMIN,
      noRecordText: config.NO_RECORD_TEXT,
      schools: [],
      schoolId: "",
      name: "",
      userTypes: [],
      userTypeName: "",
      status: "",
      instructors: [],
      paging: {
        CurrentPage: 1,
        TotalPage: "",
        SizePerPage: 20,
        Sizes: [20, 50, 100],
        SortBy: "",
      },
      totalRecords: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("cbstoken"));
      return data;
    },
  },
  watch: {
    "paging.SizePerPage": function () {
      this.paging.CurrentPage = 1;
      this.getInstructorList();
    },
    "paging.CurrentPage": function (val, oldVal) {
      if (val > this.paging.TotalPage) {
        this.paging.CurrentPage = this.paging.TotalPage;
      }
    },
    schoolId() {
      this.userTypeName = "";
      this.getSchoolUserTypes();
    },
  },
  methods: {
    search() {
      //set the state from filter
      this.$store.state.instructorFilter.schoolId = this.schoolId;
      this.$store.state.instructorFilter.instructorName = this.name;
      this.$store.state.instructorFilter.userTypeName = this.userTypeName;
      this.$store.state.instructorFilter.status = this.status;
      this.paging.CurrentPage = 1;
      this.getInstructorList();
    },
    deleteInstructor(instructorId) {
      let param = {
        Token: this.tokenObj.Token,
        Id: instructorId,
      };
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to delete the instructor?",
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          this.$store.state.isLoading = true;
          API.instructor
            .deleteInstructor(param)
            .then((response) => {
              this.$store.state.isLoading = false;
              this.$swal(response.data.message, {
                icon: response.data.success ? "success" : "error",
              });
              if (response.data.success) {
                this.paging.CurrentPage = 1;
                this.getInstructorList();
              }
            })
            .catch((error) => {
              this.$store.state.isLoading = false;
              this.$swal(error.response.data.Message, { icon: "error" });
            });
        }
      });
    },
    getInstructorList() {
      let param = {
        Token: this.tokenObj.Token,
        CurrentPage: this.paging.CurrentPage,
        SizePerPage: this.paging.SizePerPage,
        SortBy: this.paging.SortBy,
        SchoolId:
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? this.schoolId
            : this.tokenObj.SchoolId,
        Name: this.name,
        UserTypeName: this.userTypeName,
        Status: this.status,
      };
      this.$store.state.isLoading = true;
      API.instructor
        .getInstructorList(param)
        .then((response) => {
          this.$store.state.isLoading = false;
          if (response.data.success) {
            this.instructors = response.data.data;
            this.totalRecords = response.data.total;
            this.paging.TotalPage = response.data.pageCount;
          } else {
            this.$swal(response.data.message, {
              icon: "error",
            });
          }
        })
        .catch((error) => {
          this.$store.state.isLoading = false;
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSchools() {
      API.school
        .getSchools({ Token: this.tokenObj.Token })
        .then((response) => {
          if (response.data.success) {
            this.schools = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    getSchoolUserTypes() {
      let param = {
        Token: this.tokenObj.Token,
        SchoolId:
          this.tokenObj.UserType == this.userTypeMainAdmin
            ? this.schoolId
            : this.tokenObj.SchoolId,
      };
      API.school
        .getSchoolUserTypes(param)
        .then((response) => {
          if (response.data.success) {
            this.userTypes = response.data.data;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          this.$swal(error.response.data.Message, { icon: "error" });
        });
    },
    //pagination
    onCurrentPageChange(event) {
      let currentPage = event.target.value;
      if (currentPage < 1) {
        currentPage = 1;
      }
      this.paging.CurrentPage = parseInt(currentPage);
      this.getInstructorList();
    },
    first() {
      this.paging.CurrentPage = 1;
      this.getInstructorList();
    },
    prev() {
      this.paging.CurrentPage -= 1;
      this.getInstructorList();
    },
    next() {
      this.paging.CurrentPage += 1;
      this.getInstructorList();
    },
    last() {
      this.paging.CurrentPage = this.paging.TotalPage;
      this.getInstructorList();
    },
    setSortBy(payload) {
      switch (payload) {
        case "userType":
          if (this.paging.SortBy === "userType") {
            this.paging.SortBy = "userType_desc";
          } else if (this.paging.SortBy === "userType_desc") {
            this.paging.SortBy = "userType";
          } else {
            this.paging.SortBy = "userType";
          }
          break;
        case "id":
          if (this.paging.SortBy === "id") {
            this.paging.SortBy = "id_desc";
          } else if (this.paging.SortBy === "id_desc") {
            this.paging.SortBy = "id";
          } else {
            this.paging.SortBy = "id";
          }
          break;
        case "name":
          if (this.paging.SortBy === "name") {
            this.paging.SortBy = "name_desc";
          } else if (this.paging.SortBy === "name_desc") {
            this.paging.SortBy = "name";
          } else {
            this.paging.SortBy = "name";
          }
          break;
        case "contactNumber":
          if (this.paging.SortBy === "contactNumber") {
            this.paging.SortBy = "contactNumber_desc";
          } else if (this.paging.SortBy === "contactNumber_desc") {
            this.paging.SortBy = "contactNumber";
          } else {
            this.paging.SortBy = "contactNumber";
          }
          break;
        case "status":
          if (this.paging.SortBy === "status") {
            this.paging.SortBy = "status_desc";
          } else if (this.paging.SortBy === "status_desc") {
            this.paging.SortBy = "status";
          } else {
            this.paging.SortBy = "status";
          }
          break;
      }
      this.getInstructorList();
    },
  },
  created() {
    //populate the filter from state
    let instructorFilter = this.$store.state.instructorFilter;
    this.schoolId = instructorFilter.schoolId;
    this.name = instructorFilter.instructorName;
    this.userTypeName = instructorFilter.userTypeName;
    this.status = instructorFilter.status;
    this.getInstructorList();
    this.getSchools();
    this.getSchoolUserTypes();
  },
};
</script>

<style scoped>
table {
  min-height: 150px;
}
.id-col {
  width: 25%;
}
.contact-col {
  width: 20%;
}
.status-col {
  width: 150px;
}
</style>


// WEBPACK FOOTER //
// src/components/SchoolUser/SchoolAdmin/InstructorList.vue